<template>
  <div class="login-content">
    <div
      class="content"
      :style="{
        backgroundImage: `url(${transformImage(getFeUrl('/youyan-platform/png/login-bg.png'))})`,
      }"
    >
      <Resource src="~/assets/svg/logo_login.svg" />
      <div class="mt-[50px]">
        <div v-for="(item, key) in mesList" :key="key" class="tip-item">
          <iconpark-icon name="check-thin" size="22" class="mr-[20px] text-white"></iconpark-icon>
          <span class="mr-[5px]">
            <span :class="{ 'text-[22px]': item.number }">{{ item.number || item.tip1 }}</span>
            <span v-if="item.plus">+</span>
          </span>
          {{ item.tip }}
        </div>
      </div>
    </div>
    <div class="flex justify-center flex-1 py-[30px]">
      <LoginForm />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import LoginForm from './foreign.vue';

const { t: $t } = useI18n();

const mesList = [
  {
    number: 1000,
    plus: true,
    tip: $t('you-zhi-mo-ban'),
  },
  {
    number: 700,
    plus: true,
    tip: $t('chao-xie-shi-xu-ni-ren'),
  },
  {
    number: 100,
    plus: true,
    tip: $t('chao-xie-shi-san-wei-chang-jing'),
  },
  {
    tip1: $t('yun-duan-cun-chu'),
    tip: $t('xie-zuo-bian-ji'),
  },
  {
    tip1: $t('shang-yong-shou-quan'),
    tip: $t('shi-yong-an-xin'),
  },
];
</script>

<style lang="scss" scoped>
.login-content {
  @apply flex w-full h-full;
  .content {
    @apply text-white flex items-center flex-col pt-[69px] pb-[100px] w-[377px];
    background-size: 100% 100%;
    border-radius: 6px 0 0 6px;
    background-repeat: no-repeat;
    .text-shadow {
      text-shadow: 0px 2px 10px rgba(46, 41, 135, 0.3);
    }
    .tip-item {
      @apply flex items-center text-[16px] font-medium h-[35px];
      margin: 10px 0;
      text-shadow: 0px 2px 10px rgba(46, 41, 135, 0.3);
    }
  }
}
</style>
